import React, {
    useContext, useEffect
} from 'react';
import {
    Outlet, useLocation, useNavigate
} from 'react-router-dom';
import {
    Context
} from 'shared/context/GlobalState';
import styled from 'styled-components';

const StyledContainer = styled.div`
    display: flex;
    flex-grow: 1;
    padding: 0px !important;
    height: 100%;
    overflow-x: hidden;
    width: 100vw;
`;
export const ProtectedRoute = () => {

    const {
        isAuth, loading
    } = useContext(Context);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && !isAuth) {
            sessionStorage.setItem('redirect-url', location.pathname);
            navigate('/auth/login');
        }
    }, [location.pathname, isAuth, loading, navigate]);

    return (
        <StyledContainer>
            <Outlet />
        </StyledContainer>
    );
};